export default __webpack_public_path__ + "7754c220114d5e7ec2ec07be4e91f378.png";